import {Component, OnInit} from '@angular/core';
import {PerformanceBonusService} from '../../../shared/services/performance-bonus.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-performance-bonus',
  templateUrl: './performance-bonus.component.html',
  styleUrls: ['./performance-bonus.component.scss']
})
export class PerformanceBonusComponent implements OnInit {
  submitting = false;
  performanceBonus = [];
  total: any = 0;
  showSearch: any = false;
  searchForm: FormGroup;
  bsConfig: Partial<BsDatepickerConfig>;
  pagination = {
    page: 1,
    total: null,
    perpage: 15,
    pages: null
  };

  constructor(public performanceBonusService: PerformanceBonusService,
              private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.searchForm = this.fb.group({
      'downline_id': [''],
      'commission': [''],
      'tds': [''],
      'total_sale': [''],
      'difference_slab': ['']
    });
    this.get();
  }

  get(params: any = {}) {
    params.page = this.pagination.page;
    params.perpage = this.pagination.perpage;
    this.submitting = true;
    this.performanceBonus = [];
    this.performanceBonusService.get(params).subscribe(data => {
      if (data && data['data'] && data['data'].length > 0) {
        this.performanceBonus = data['data'];
        this.pagination = {
          page: data['pagination'].page,
          total: data['pagination'].total,
          perpage: data['pagination'].perpage,
          pages: data['pagination'].pages,
        };
        this.total = data.total_commission;
        this.triggerScroll();
      } else {
        this.performanceBonus = [];
      }
      this.submitting = false;
    }, error => {
      this.submitting = false;
    });
  }

  triggerScroll() {
    window.scrollTo(500, 500);
    window.scrollTo(500, 0);
  }

  onPageChange(page) {
    this.pagination.page = page;
    this.get();
  }

  search() {
    this.pagination = {
      page: 1,
      total: null,
      perpage: 15,
      pages: null
    };
    let params = {
      'downline_id': (this.searchForm && this.searchForm.value) ? this.searchForm.value.downline_id : '',
      'commission': (this.searchForm && this.searchForm.value) ? this.searchForm.value.commission : '',
      'tds': (this.searchForm && this.searchForm.value) ? this.searchForm.value.tds : '',
      'total_sale': (this.searchForm && this.searchForm.value) ? this.searchForm.value.total_sale : '',
      'difference_slab': (this.searchForm && this.searchForm.value) ? this.searchForm.value.difference_slab : '',
    };
    this.get(params);
  }
}
